'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _session = require('../session');

var _session2 = _interopRequireDefault(_session);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Person = function () {
  function Person($http, record) {
    _classCallCheck(this, Person);

    this.$http = $http;

    if ((typeof record === 'undefined' ? 'undefined' : _typeof(record)) === 'object') {
      this._record = record;
    } else {
      this._record = {
        id: record
      };
    }

    this._prefix = IFEIS_API_URI + '/api/accounts/persons/' + this._record.id;
  }

  _createClass(Person, [{
    key: 'toJSON',
    value: function toJSON() {
      return JSON.stringify(this._record);
    }

    // FIXME(joshdmiller): This should probably return a promise, so we can optionally fetch the
    // account if one wasn't provided in the constructor. To decrease the diff, we assume this is not
    // called without getting the person through an api call.

  }, {
    key: 'get',
    value: function get() {
      return _extends({}, this._record);
    }
  }, {
    key: 'name',
    value: function name() {
      return this._record.fname + ' ' + this._record.lname;
    }
  }, {
    key: 'id',
    value: function id() {
      return this._record.id;
    }
  }, {
    key: 'update',
    value: function update(person) {
      var _this = this;

      return this.$http.put(this._prefix, person).then(function (r) {
        return _this._record = r;
      }).then(function (r) {
        return _this;
      });
    }
  }, {
    key: 'setSchool',
    value: function setSchool(school_id) {
      var _this2 = this;

      return this.$http.put(this._prefix + '/school', { school_id: school_id }).then(function (r) {
        return _this2._record = r;
      }).then(function (r) {
        return _this2;
      });
    }
  }, {
    key: 'rmSchool',
    value: function rmSchool() {
      var _this3 = this;

      return this.$http.delete(this._prefix + '/school').then(function (r) {
        return _this3._record = r;
      }).then(function (r) {
        return _this3;
      });
    }
  }]);

  return Person;
}();

var Account = function (_Person) {
  _inherits(Account, _Person);

  function Account($http, acct, fSession) {
    _classCallCheck(this, Account);

    var _this4 = _possibleConstructorReturn(this, (Account.__proto__ || Object.getPrototypeOf(Account)).call(this, $http, acct));

    _this4.fSession = fSession;
    _this4._accountPrefix = IFEIS_API_URI + '/api/accounts/' + _this4._record.id;
    return _this4;
  }

  _createClass(Account, [{
    key: 'update',
    value: function update(account) {
      var _this5 = this;

      return this.$http.put(this._accountPrefix, account).then(function (user) {
        return _this5.fSession.update(user);
      }).then(function (r) {
        return _this5._record = r;
      }).then(function (r) {
        return _this5;
      });
    }

    /**
     * Dependents
     */

  }, {
    key: 'dependents',
    value: function dependents() {
      var _this6 = this;

      return this.$http.get(this._accountPrefix + '/dependents').then(function (persons) {
        return persons.map(function (p) {
          return new Person(_this6.$http, p);
        });
      });
    }
  }, {
    key: 'createDependent',
    value: function createDependent(dependent) {
      var _this7 = this;

      return this.$http.post(this._accountPrefix + '/dependents', dependent).then(function (p) {
        return new Person(_this7.$http, p);
      });
    }
  }, {
    key: 'deleteDependent',
    value: function deleteDependent(dependent) {
      return this.$http.delete(this._accountPrefix + '/dependents/{dependent.id}');
    }

    /**
     * Payments
     * FIXME: deprecate
     */

  }, {
    key: 'payments',
    value: function payments() {
      return this.$http.get(this._accountPrefix + '/payments');
    }

    // FIXME: deprecate

  }, {
    key: 'paymentsDue',
    value: function paymentsDue() {
      return this.$http.get(this._accountPrefix + '/payments-due');
    }

    /**
     * Feiseanna
     */

  }, {
    key: 'attachFeis',
    value: function attachFeis(id) {
      return this.$http.post(this._accountPrefix + '/feiseanna', { id: id });
    }
  }, {
    key: 'detachFeis',
    value: function detachFeis(id) {
      return this.$http.delete(this._accountPrefix + '/feiseanna/' + id);
    }
  }]);

  return Account;
}(Person);

var fAccountService = function () {
  function fAccountService($http, fSession) {
    _classCallCheck(this, fAccountService);

    this._prefix = IFEIS_API_URI + '/api/accounts';
    this.$http = $http;
    this.fSession = fSession;
  }

  _createClass(fAccountService, [{
    key: 'one',
    value: function one(id) {
      var _this8 = this;

      return this.$http.get(this._prefix + '/' + id).then(function (acct) {
        return new Account(_this8.$http, acct, _this8.fSession);
      });
    }
  }, {
    key: 'oneWithoutData',
    value: function oneWithoutData(id) {
      return new Account(this.$http, id, this.fSession);
    }
  }, {
    key: 'me',
    value: function me(id) {
      var _this9 = this;

      return this.$http.get(this._prefix + '/me').then(function (acct) {
        return new Account(_this9.$http, acct, _this9.fSession);
      });
    }
  }, {
    key: 'getFromPerson',
    value: function getFromPerson(id) {
      var _this10 = this;

      return this.$http.get(IFEIS_API_URI + '/api/accounts/for-person/' + id).then(function (acct) {
        return new Account(_this10.$http, acct, _this10.fSession);
      });
    }
  }, {
    key: 'onePerson',
    value: function onePerson(id) {
      var _this11 = this;

      return this.$http.get(this._prefix + '/persons/' + id).then(function (acct) {
        return new Person(_this11.$http, acct);
      });
    }
  }, {
    key: 'onePersonWithoutData',
    value: function onePersonWithoutData(id) {
      return new Person(this.$http, id);
    }
  }]);

  return fAccountService;
}();

exports.default = angular.module('ifeis.accounts', ['ifeis.session']).service('fAccountService', fAccountService);


//////////////////
// WEBPACK FOOTER
// ./accounts/index.js
// module id = 100
// module chunks = 0